export const CURRENT_USER_LOCAL_STORAGE_KEY = 'currentUser';
